import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import {resolveExposuresOverlap} from 'helpers/exposure';
import Action from 'components/organisms/random-team-stacking/actions';

class TeamExposure extends Component {
    constructor(props) {
        super(props);
        const {stacking, team} = props;
        this.state = {
            min: stacking.getTeamMinExposure(team),
            max: stacking.getTeamMaxExposure(team),
        };
        this.isValueBeingChanged = {
            min: false,
            max: false,
        };
    }

    onChange(exposureType, value) {
        this.isValueBeingChanged[exposureType] = true;
        this.setState({[exposureType]: value});
    }

    onBlur(exposureType, value) {
        const limitValue = 'min' === exposureType ? 0 : 100;
        let exposure = {
            min: this.getActualValue('min'),
            max: this.getActualValue('max'),
        };
        exposure[exposureType] = NumberHelper.prepareInt(value, limitValue).limitByRange(0, 100, 0, 100).get();

        exposure = resolveExposuresOverlap(exposure, exposureType);

        this.setState({...exposure});

        this.isValueBeingChanged[exposureType] = false;

        this.props.dispatch(Action.set('TeamExposure', this.props.team, exposure));
    }

    getActualValue(exposureType) {
        let value = this.state[exposureType];
        if (!this.isValueBeingChanged[exposureType]) {
            const {team, stacking} = this.props;
            value = stacking.getTeamExposure(team, exposureType);
        }
        return value;
    }

    render() {
        const exposureMin = this.getActualValue('min');
        const exposureMax = this.getActualValue('max');

        return (
            <div className="min-max-group">
                <div className="percent-in">
                    <input
                        onBlur={(e) => ::this.onBlur('min', e.target.value)}
                        onChange={(e) => ::this.onChange('min', e.target.value)}
                        value={`${exposureMin}`}
                        type="text"
                        className="form-control"
                    />
                    <span className="percent">%</span>
                </div>
                <div className="percent-in">
                    <input
                        onBlur={(e) => ::this.onBlur('max', e.target.value)}
                        onChange={(e) => ::this.onChange('max', e.target.value)}
                        value={`${exposureMax}`}
                        type="text"
                        className="form-control"
                    />
                    <span className="percent">%</span>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking} = state;
    return {
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(TeamExposure);
